export enum EVENTS_KEYS {
  ESTABELECIMENTO_RETORNAR_LOCALIZAÇÃO_DEFAULT = 'ESTABELECIMENTO_RETORNAR_LOCALIZAÇÃO_DEFAULT',
}
